import { render, staticRenderFns } from "./DependentBusinessVisa.vue?vue&type=template&id=76a21032&"
import script from "./DependentBusinessVisa.vue?vue&type=script&lang=js&"
export * from "./DependentBusinessVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports